export default "__VITE_ASSET__BqVkfb_f__"